<app-layout pageTitle="Início" [fillPrimary]="true">
  <section class="picker">
    <div class="picker-controls">

      <button mat-icon-button (click)="changeMonth(-1)">
        <mat-icon>keyboard_arrow_left</mat-icon>
      </button>

      <mat-form-field appearance="standard" class="clean-select">
        <mat-select [value]="selectedMonth" (selectionChange)="onMonthChange($event)">
          <mat-option *ngFor="let m of months" [value]="m">
            {{ m.label }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <button mat-icon-button (click)="changeMonth(1)">
        <mat-icon>keyboard_arrow_right</mat-icon>
      </button>

    </div>
  </section>

  <section class="dashboard">
    <app-incomes-and-expenses [selectedDate]="selectedMonth?.date"></app-incomes-and-expenses>
    <app-cash-flow-by-period [selectedDate]="selectedMonth?.date"></app-cash-flow-by-period>
    <app-apportionment-by-cost-center [selectedDate]="selectedMonth?.date"></app-apportionment-by-cost-center>
  </section>
</app-layout>
